module.exports = __webpack_public_path__ + "static/wall-c70a3dbeb72a293650420c9c13be7ce2.jpg";